import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Head from "next/head";
import React from "react";
var Favicon = function() {
    return /*#__PURE__*/ _jsxs(Head, {
        children: [
            /*#__PURE__*/ _jsx("link", {
                rel: "shortcut icon",
                href: "/images/common/favicon.ico"
            }),
            /*#__PURE__*/ _jsx("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "/images/common/apple-touch-icon-precomposed.png"
            })
        ]
    });
};
export default Favicon;
